// extracted by mini-css-extract-plugin
module.exports = {"projectsSection":"k_F","projects":"k_G","eyebrow":"k_H","description":"k_k","itemProjects":"k_J","imageWrapper":"k_K"};